(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6670],{

/***/ 46665:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workbench",
      function () {
        return __webpack_require__(15619);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": () => (/* binding */ __N_SSP),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27721);




antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].config */ .ZP.config({
    maxCount: 1
});
const MobileWorkbench = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(1970), __webpack_require__.e(8937), __webpack_require__.e(7503), __webpack_require__.e(8146), __webpack_require__.e(650), __webpack_require__.e(228), __webpack_require__.e(7722), __webpack_require__.e(1204), __webpack_require__.e(8787), __webpack_require__.e(5880), __webpack_require__.e(6656)]).then(__webpack_require__.bind(__webpack_require__, 58793)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(58793)
            ]
    },
    ssr: false
});
const WebWorkbench = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(4640), __webpack_require__.e(8146), __webpack_require__.e(650), __webpack_require__.e(6753), __webpack_require__.e(228), __webpack_require__.e(7722), __webpack_require__.e(938), __webpack_require__.e(1204), __webpack_require__.e(9330), __webpack_require__.e(8787), __webpack_require__.e(5194), __webpack_require__.e(915), __webpack_require__.e(5880), __webpack_require__.e(3211)]).then(__webpack_require__.bind(__webpack_require__, 2401)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2401)
            ]
    },
    ssr: false
});
const Workbench = (props)=>{
    const { isMobile , isPersonal  } = props;
    return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileWorkbench, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WebWorkbench, {
        isPersonal: isPersonal
    });
};
var __N_SSP = true;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Workbench);


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2991,5700,9774,2888,179], () => (__webpack_exec__(46665)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);